import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {MetadataEntry} from '../../../services/vte/vehicle-transaction-view.service';

@Component({
    selector: 'app-metadata-panel',
    standalone: true,
    imports: [CommonModule, RouterLink],
    template: `
        <section class="metadata-panel" *ngIf="entries.length">
            <h3 class="metadata-panel__title" *ngIf="title">{{ title }}</h3>
            <dl class="metadata-panel__list">
                <div class="metadata-panel__item" *ngFor="let entry of entries">
                    <dt>
                        {{ entry.label }}
                        <abbr *ngIf="entry.help" class="metadata-panel__help" [title]="entry.help">ⓘ</abbr>
                    </dt>
                    <dd>
                        <a *ngIf="entry.routerLink?.length"
                           class="metadata-panel__link"
                           [routerLink]="entry.routerLink!"
                           [queryParams]="entry.queryParams || null">
                            {{ entry.value }}
                        </a>
                        <ng-container *ngIf="!entry.routerLink?.length">{{ entry.value }}</ng-container>
                    </dd>
                </div>
            </dl>
        </section>
    `,
    styles: [`
        .metadata-panel {
            padding: 1.25rem;
            border: 1px solid #E5E7EB;
            border-radius: 0.75rem;
            background: #fff;
        }

        .metadata-panel__title {
            margin: 0 0 0.75rem;
            font-size: 1rem;
            font-weight: 700;
            color: #111827;
        }

        .metadata-panel__list {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
            gap: 0.75rem;
            margin: 0;
        }

        .metadata-panel__item dt {
            margin: 0 0 0.2rem;
            font-size: 0.72rem;
            font-weight: 700;
            letter-spacing: 0.04em;
            text-transform: uppercase;
            color: #6B7280;
        }

        .metadata-panel__help {
            margin-left: 0.2rem;
            text-decoration: none;
            cursor: help;
            font-weight: 700;
            color: #9CA3AF;
        }

        .metadata-panel__item dd {
            margin: 0;
            font-size: 0.875rem;
            color: #111827;
            word-break: break-word;
        }

        .metadata-panel__link {
            color: #1D4ED8;
            font-weight: 600;
            text-decoration: none;
        }

        .metadata-panel__link:hover {
            text-decoration: underline;
        }
    `],
})
export class MetadataPanelComponent {
    @Input() title = '';
    @Input() entries: MetadataEntry[] = [];
}
